import type { Geolocation } from "@/lib/geolocation"

import type { LocationIQ } from "./types"

export const transformLocationIQAddressToBingFormat = (
  response: LocationIQ.AutocompleteResponse | LocationIQ.ReverseGeocodeResponse
): Geolocation.Bing.Address => {
  const address = response.address || {}

  // Get city/locality in order of preference
  const locality = address.city || address.town || address.village || ``

  // Build address line from components
  const addressParts = []
  if (address.house_number) {
    addressParts.push(address.house_number)
  }
  if (address.road) {
    addressParts.push(address.road)
  }
  const addressLine = addressParts.join(` `)

  // Build simplified formatted address
  const formattedAddressParts = []
  if (addressLine) {
    formattedAddressParts.push(addressLine)
  }
  if (address.neighbourhood || address.suburb) {
    formattedAddressParts.push(address.neighbourhood || address.suburb)
  }
  if (locality) {
    formattedAddressParts.push(locality)
  }
  const formattedAddress = formattedAddressParts.join(`, `)

  return {
    addressLine,
    adminDistrict: address.state || ``,
    adminDistrict2: address.county || ``,
    countryRegion: address.country || ``,
    countryRegionIso2: address.country_code?.toUpperCase() || ``,
    formattedAddress: formattedAddress || response.display_name || ``,
    landmark: ``, // LocationIQ doesn't provide landmark data
    locality,
    neighbourhood: address.neighbourhood || address.suburb || ``,
    postalCode: address.postcode || ``,
    streetName: address.road || ``,
  }
}

export const extractLatlngFromLocationIQResponse = (
  response: LocationIQ.AutocompleteResponse | LocationIQ.ReverseGeocodeResponse
): Geolocation.Latlng => {
  return {
    lat: parseFloat(response.lat),
    lng: parseFloat(response.lon),
  }
}
